import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Header from "./imports/Header";
import Footer from "./imports/Footer";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./pages/ProtectedRoute";
import { UserProvider } from "./pages/UserContext";

// ⚡ Lazy loading das páginas
const Galeria = React.lazy(() => import("./pages/Galeria"));
const Contact = React.lazy(() => import("./pages/Contact"));
const About = React.lazy(() => import("./pages/About"));
const Testimonials = React.lazy(() => import("./pages/Testimonials"));
const Clients = React.lazy(() => import("./pages/Clients"));
const Services = React.lazy(() => import("./pages/Services"));
const BPO = React.lazy(() => import("./sub_pages/BPO"));
const RH = React.lazy(() => import("./sub_pages/RH"));
const Scanning = React.lazy(() => import("./sub_pages/Scanning"));
const Signature = React.lazy(() => import("./sub_pages/Signature"));
const Documents = React.lazy(() => import("./sub_pages/Documents"));
const Auth = React.lazy(() => import("./pages/Auth"));
const Form = React.lazy(() => import("./pages/Form"));
const FormDemo = React.lazy(() => import("./pages/FormDemo"));
const AccessPortal = React.lazy(() => import("./pages/AccessPortal")); // ✅ nova rota

/* ============================================
   💬 JivoChat – carregamento inteligente
   ============================================ */

function loadJivoChat() {
  if (window.jivo_init) return; // evita duplicar script
  window.jivo_init = true;
  const script = document.createElement("script");
  script.src = "//code.jivosite.com/widget/sFkwWzkWlX";
  script.async = true;
  document.body.appendChild(script);
}

// 1️⃣ Adia o chat por tempo (5s após load)
window.addEventListener("load", () => {
  setTimeout(loadJivoChat, 5000);
});

// 2️⃣ Ou carrega antes se o usuário interagir
["scroll", "mousemove", "touchstart"].forEach(evt => {
  window.addEventListener(
    evt,
    () => {
      loadJivoChat();
    },
    { once: true }
  );
});

/* ============================================
   ⚙️ Montagem da aplicação
   ============================================ */

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // ⚠️ React.StrictMode duplicava renders no build → REMOVIDO pra performance
  <UserProvider>
    <Suspense fallback={<div style={{ height: "1px" }} />}>
      <Router>
        <Header />

        <Routes>
          {/* Páginas principais */}
          <Route path="/" element={<App />} />
          <Route path="/galeria" element={<Galeria bgColor="#CACACA" />} />
          <Route path="/contact" element={<Contact bgColor="#CACACA" />} />
          <Route path="/about" element={<About bgColor="#CACACA" />} />
          <Route path="/clients" element={<Clients bgColor="#CACACA" />} />
          <Route path="/services" element={<Services bgColor="#CACACA" />} />
          <Route path="/bpo" element={<BPO bgColor="#CACACA" />} />
          <Route path="/rh" element={<RH bgColor="#CACACA" />} />
          <Route path="/scanning" element={<Scanning bgColor="#CACACA" />} />
          <Route path="/signature" element={<Signature bgColor="#CACACA" />} />
          <Route path="/documents" element={<Documents bgColor="#CACACA" />} />
          <Route path="/formdemo" element={<FormDemo bgColor="#CACACA" />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/portais" element={<AccessPortal />} />

          {/* Rotas protegidas */}
          <Route element={<ProtectedRoute />}>
            <Route path="/form" element={<Form />} />
          </Route>
        </Routes>

        <Footer />
      </Router>
    </Suspense>
  </UserProvider>
);

reportWebVitals();
